import React, { PureComponent } from 'react';
import classNames from 'classnames';

import { BaseInputProps } from '../types';

import { Num } from './Num';

export interface NumRangeProps extends BaseInputProps {
  value?: { min?: number; max?: number };

  onChange?(val?: { min?: number; max?: number }): void;

  isPercentage?: boolean;
}

export class NumRange extends PureComponent<NumRangeProps> {
  onChange = (key: 'min' | 'max', val: number) => {
    const value = { ...this.props.value } as any;
    value[key] = val;
    this.props.onChange?.(value);
  };

  render() {
    return (
      <div
        className={classNames(
          'flex',
          'gap-1',
          this.props.className,
        )}
        style={this.props.style}
      >
        {this.props.readonly ? '(' : ''}
        <Num
          placeholder={'Min'}
          value={this.props.value?.min}
          onChange={this.onChange.bind(null, 'min')}
          isPercentage={this.props.isPercentage}
          readonly={this.props.readonly}
          onBlur={this.props.onBlur}
          inputWidth={60}
        />
        <span
          style={
            this.props.readonly ? { marginLeft: 0, marginRight: 4 } : undefined
          }
        >
          {this.props.readonly ? ',' : '~'}
        </span>
        <Num
          placeholder={'Max'}
          value={this.props.value?.max}
          onChange={this.onChange.bind(null, 'max')}
          isPercentage={this.props.isPercentage}
          readonly={this.props.readonly}
          onBlur={this.props.onBlur}
          inputWidth={60}
        />
        {this.props.readonly ? ')' : ''}
      </div>
    );
  }
}
